export enum ValidationType {
  Internal = 'internal',
  RAP = 'rap',
  External = 'external',
}

export enum ValidationSubType {
  Proficiency = 'proficiency',
  Validation = 'validation',
}

export type CourseStatusTooltip = {
  validationType: ValidationType;
  validationSubType?: ValidationSubType | null;
  examGrade?: string | null;
  finalGrade?: string | null;
  externalGrade?: string | null;
  externalCourseName?: string | null;
  code?: string;
};

export interface CoursesBySemestersExtraCourse {
  name: string;
  state?: string;
}
